import React from 'react';
import connectToStores from 'alt-store-connect';
import Sidebar from '../sidebar';
import SidebarComponent from '../page/sidebar-component';
import PageStore from '../../stores/page';
import DragContext from '../../utils/dragDropContext';
import classnames from 'classnames';

import { Components, Groups } from '../../config/components';
import { Glyphicon, Popover } from 'react-bootstrap';

@connectToStores
class PageSidebar extends React.Component {

    static getStores() {
        return [PageStore];
    }

    static getPropsFromStores(props) {
        return {
            page: PageStore.getState().models[props.pageId],
        };
    }

    render() {
        const sidebarHeader = (
            <div className="page-editor-sidebar-header">
                <Glyphicon glyph="chevron-right" />
                <div>
                    <Glyphicon glyph="chevron-left" />
                    &nbsp;
                    <span>Components</span>
                </div>
            </div>
        );

        const sidebarItems = this.props.page ? Groups.map((group) => {
            const items = [<li key={group.name} className="heading">{group.label}</li>];
            const components = Components.filter(
                component => component.group === group.name && component.tenant === undefined,
            )
                .map((component) => {
                    const popover = (
                        <Popover
                            key={component.id}
                            id={component.id}
                            className="sidebar-popover"
                        >
                            <h5>{component.tooltip.title}</h5>
                            <div className="popover-content-body">
                                {component.tooltip.content}
                            </div>
                        </Popover>
                    );

                    return (
                        <SidebarComponent
                            key={component.id}
                            popover={popover}
                            component={component}
                            container={document.querySelector('#manywho-draw')}
                            editing={this.props.page.editing}
                            droppedOn={this.props.page.droppedOn}
                        />
                    );
                });

            return items.concat(components);
        }) : [];

        const className = classnames({
            'page-sidebar': true,
            hidden: !this.props.isActive,
        });

        return (<Sidebar isCollapsed header={sidebarHeader} class={className}>{sidebarItems}</Sidebar>);
    }
}

export default DragContext(PageSidebar);
